module.exports = __webpack_public_path__ + "img/mastercard.feeac757.png";